module.exports = __webpack_public_path__ + "fonts/latobold.85d339d9.ttf";